const e = {
  extends: "Pick6",
  logo: !0
};
export {
  e as default
};
